// extracted by mini-css-extract-plugin
export default {"container":"progress-bar_container__D7lUy","icon":"progress-bar_icon__yrVJS"};